export const ENDPOINT = "https://theoutletapi.herokuapp.com/api/v1"

export const getJWT = () => {
    return localStorage.getItem('JWT_TOKEN_OUTLET')
}

export const getOutletSessionId = () => {
    return localStorage.getItem('THE_OUTLET_SESSION_ID')
}